export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="sticky top-0 z-20 bg-[#0A0A0A]/80 backdrop-blur-xl hairline-b px-8 py-4 flex items-center justify-between">
      <div>
        <h1 data-testid="page-title" className="text-lg font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-xs text-white/50 mt-0.5">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{actions}</div>
    </div>
  );
}
